 /* global window, console, fetch  */

import mergeObject from '../utils/merge-object';
import status from '../utils/status';
import polyfill from '../utils/polyfill';
import dataTransformerFactory from '../transformers/transformer-factory';

// change these imports per component
import controller from './live-table-controller';
import view from './live-table-view';
import inlineListener from './inline-table-listener';

// INITIALISE COMPONENT
// @param rootElement {htmlNode} root dom element of component
// @param options {object} object of optional parameters for component
export default function(rootElement, options) {
  // set component defaults;
  const defaults = {
    // url endpoint of json data
    url: null,
    // refresh interval in seconds
    interval: rootElement.getAttribute('data-interval') ? rootElement.getAttribute('data-interval') : 15,
    // url of fetch polyfill
    fetchPolyfill: 'https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=fetch,Promise'
  };

  // sets up listener for inline table links
  inlineListener();

  // merge passed options into defaults
  mergeObject(defaults, options);
  // make first request...
  // (polyfill the fetch api if not available)
  polyfill('fetch' in window, defaults.fetchPolyfill, () => {
    requestData();
  });

  // function to request data using fetch api
  // ensure this is polyfilled for non supporting browsers
  function requestData() {
    // recall request data on the specified interval, converting seconds to milliseconds
    setTimeout(
      requestData,
      defaults.interval * 1000
    );

    // update url
    defaults.url = rootElement.getAttribute('data-url');

    const sportType = rootElement.getAttribute('data-sport-type');

    // if no url, bail out
    if (!defaults.url) {
      return;
    }

    // request json data using fetch
    fetch(defaults.url)
    .then(status)
    .then(response => response.json())
    .then(response => dataTransformerFactory(response, sportType))
    .then(controller.bind(null, view))
    .catch(error => console.error(error));
  }
}
